import { AppMode } from '@iheartjane/dm-sdk';
import type { ProductKind } from '@iheartjane/types';

import type { Store } from '@jane/shared/types';
import { generateCustomLabel } from '@jane/shared/util';

import { isMenuCategory } from '../../../types';
import type { MenuCategory } from '../../../types';
import { categories } from '../categories/categories';

interface CustomCategoryLabelArgs {
  kind: ProductKind | MenuCategory;
  store: Store;
}

export const customCategoryLabel = ({
  kind,
  store,
}: CustomCategoryLabelArgs) => {
  const label = generateCustomLabel({
    appMode: AppMode.Kiosk,
    store,
    attribute: kind,
    fallback: kind,
  });

  return isMenuCategory(label) ? categories[label].title : label;
};
